<template>
    <span class="input-wrapper" :class="wrapperCssClass">
        <label :for="id">
            <input
                type="checkbox"
                :name="name"
                :id="id"
                :class="invalidClass"
                :style="cssStyle"
                :autocomplete="autocomplete"
                @change="update($event.target.checked)"
                v-model="checked"
            >{{ label }}
        </label>
    </span>
</template>
<script>
    import FormInputMixin from '../../../mixins/Form/Input.vue';
    export default {
        mixins: [FormInputMixin],
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: {
            trueValue: {
                default: true
            },
            falseValue: {
                default: false
            }
        },
        data() {
            return {
                checked: this.value === this.trueValue
            }
        },
        mounted() {
            this.update(this.checked);
        },
        methods: {
            update(value) {
                let checkedValue = value ? this.trueValue : this.falseValue;
                if (this.inputEvent) {
                    EventBus.fire(this.inputEvent, checkedValue);
                }
                this.$emit('change', checkedValue);
            }
        }
    }
</script>